import React from 'react';
import { CircleDot, Swords, Target, Trophy } from 'lucide-react';

// Sport icon mapping (consistent with AdminSports)
export const SPORT_ICONS = {
  'soccer': CircleDot,
  'rugby': Swords,
  'gaelic-football': Target,
  'hurling-camogie': Swords,
};

export const SportIcon = ({ sport, className = 'w-4 h-4' }) => {
  const Icon = SPORT_ICONS[sport?.slug] || Trophy;
  return <Icon className={className} />;
};

export default SportIcon;
